export { default } from './FattyPattyDialog';
